import React, { memo } from 'react';
import { Checkbox, RadioButton, Tooltip } from '@fourthwall/components';
import * as S from './ProductsListItemInput.styled';
export const ProductsListItemInput = memo(({ multiple, selectMode, item, value, disabled, onSelect, onBulkSelect, disabledMessage, }) => {
    const getInput = () => {
        if (multiple) {
            const isBulkSelect = selectMode === 'VARIANTS' && item.type === 'OFFER';
            return (React.createElement(Checkbox, { id: item.id, value: value, onValueChange: isBulkSelect ? onBulkSelect(item.variantsIds) : onSelect(item.id), indeterminate: isBulkSelect, disabled: disabled }));
        }
        if (selectMode === 'VARIANTS' && item.type === 'OFFER') {
            return React.createElement(S.InputSpacing, null);
        }
        return (React.createElement(S.RadioButtonWrapper, null,
            React.createElement(RadioButton, { value: value, checkedValue: item.id, disabled: disabled })));
    };
    const input = getInput();
    return disabledMessage ? React.createElement(Tooltip, { reference: input }, disabledMessage) : input;
});
